/**
 * How a navigation row reads when it is the page you are on, and when it is
 * not — the one treatment both shells' rails share, so they cannot drift.
 */
export const NAV_ROW_ACTIVE =
  "relative bg-surface-2/55 font-medium text-ink before:absolute before:inset-y-2 before:left-0 before:w-0.5 before:rounded-full before:bg-accent-text";

/** A navigation row that is not the current page. */
export const NAV_ROW_IDLE = "font-normal text-ink-2 hover:bg-surface-2/35 hover:text-ink";
